/**
 * Convert HTML-flavored rich text into plain text suitable for plain-text
 * fields (e.g., seeding a textarea from an HTML-rich source field). Uses the
 * browser's DOMParser so entities are decoded correctly without depending on
 * a third-party HTML parser.
 *
 * Block-level elements are joined with newlines so the layout reads sensibly
 * when stripped of formatting.
 */
export function richTextToPlainText(input: string | null | undefined): string {
  if (input === null || input === undefined || input === '') {
    return '';
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(input, 'text/html');

  const blockTags = new Set(['P', 'DIV', 'LI', 'BR', 'TR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']);
  const parts: string[] = [];

  function walk(node: Node): void {
    if (node.nodeType === Node.TEXT_NODE) {
      parts.push(node.textContent ?? '');
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const el = node as Element;
    const tag = el.tagName.toUpperCase();

    if (tag === 'BR') {
      parts.push('\n');
      return;
    }

    for (const child of Array.from(el.childNodes)) {
      walk(child);
    }

    if (blockTags.has(tag)) {
      parts.push('\n');
    }
  }

  walk(doc.body);

  return parts.join('').replace(/\n+/g, '\n').trim();
}
